import { render, staticRenderFns } from "./UserDepartmentDetailTable.vue?vue&type=template&id=0559d36e&scoped=true&"
import script from "./UserDepartmentDetailTable.vue?vue&type=script&lang=js&"
export * from "./UserDepartmentDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDepartmentDetailTable.vue?vue&type=style&index=0&id=0559d36e&lang=scss&scoped=true&"
import style1 from "./UserDepartmentDetailTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0559d36e",
  null
  
)

export default component.exports